import { AfterViewInit, Component, Input, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { I18nTranslator } from '../../../../i18n/translate';
import { GCFarm, GCParcel } from '../../../../models/agrorendement-genconsole.model';
import { ModalService } from '../../../../services/modal.service';
import { ARGenConsoleService } from '../../../../services/agrorendement-genconsole.service';
import { TranslatePipe } from '../../../../pipes/translate.pipe';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'ar-genconsole-filldose-cmp',
  templateUrl: './genconsole.filldose.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, CommonModule, TranslatePipe, FormsModule],
  providers: [ARGenConsoleService],
})
export class ARGenConsoleFillDoseComponent implements OnInit, AfterViewInit {
  @Input()
  culture: string;

  @ViewChildren('parcelDose') parcelDoseFields: any;
  @ViewChild('form') form: any;

  @Input()
  farms: Array<GCFarm>;

  @Input()
  parcelOriginalZonage: Set<number>;

  @Input()
  parcels: Array<GCParcel>;

  constructor(
    private genconsoleService: ARGenConsoleService,
    private i18nTranslator: I18nTranslator,
    private modal: ModalService,
    private router: Router,
  ) {}

  getParcels() {
    const farmIds_arr = this.farms.map((farm) => farm.id);
    this.genconsoleService.getParcelsForFarms(this.culture, farmIds_arr).subscribe(
      (parcels: GCParcel[]) => this.handleParcels(parcels),
      (e) => {
        this.handleError(e);
      },
    );
  }

  handleError(e: any) {
    this.modal.alert(this.i18nTranslator.translate('ar.gc.error.recupDoses'));
  }

  handleParcels(parcels: GCParcel[]) {
    for (const parcel of parcels) {
      parcel.dosePreconisee = Math.round(parcel.dosePreconisee);
      if (parcel.doseConsole == null) {
        // identique
        parcel.doseConsole = Math.round(parcel.dosePreconisee);
      } else {
        parcel.doseConsole = Math.round(parcel.doseConsole);
      }
    }

    // pour que la ref de this.parcels reste identique
    this.parcels.push(...parcels);

    const farmParcelIndex = new Map<number, Array<GCParcel>>();
    this.parcels.forEach((parcel) => {
      const farmId = parcel.farmId;
      let farmParcels = farmParcelIndex.get(farmId);
      if (!farmParcels) {
        farmParcels = new Array<GCParcel>();
        farmParcelIndex.set(farmId, farmParcels);
      }
      farmParcels.push(parcel);
    });

    this.farms.forEach((farm) => {
      const parcels = farmParcelIndex.get(farm.id);
      // vider
      if (parcels) {
        farm.parcels = parcels;
      } else {
        farm.parcels = [];
      }
    });
  }

  ngOnInit() {
    this.parcels.splice(0, this.parcels.length);

    this.getParcels();
  }

  ngAfterViewInit() {}

  isOriginalZonage(parcel: GCParcel) {
    return this.parcelOriginalZonage.has(parcel.id);
  }

  setOriginalZonage(parcel: GCParcel, event: any) {
    const value: boolean = event.target.checked;
    if (value) {
      this.parcelOriginalZonage.add(parcel.id);
    } else {
      if (this.isOriginalZonage(parcel)) {
        this.parcelOriginalZonage.delete(parcel.id);
      }
    }
  }
}
